import { Avatar } from '@chakra-ui/react';
import { ChatRoomType } from 'enums/modules/chat/chatRoomType';
import { FC } from 'react';

import chatEmployeeImage from 'assets/img/thumbnail/chat-employee.jpeg';

interface Props {
  avatar: string | null;
  roomType: ChatRoomType;
  name?: string | null;
  size?: string;
  fallbackAvatar?: string;
}

const ChatRoomThumbnail: FC<Props> = ({
  avatar,
  roomType,
  name,
  size,
  fallbackAvatar,
}) => {
  const defaultAvatar = {
    [ChatRoomType.System]: chatEmployeeImage,
    [ChatRoomType.CommunityManager]: chatEmployeeImage,
    [ChatRoomType.PersonalManager]: chatEmployeeImage,
    [ChatRoomType.Group]: chatEmployeeImage,
    [ChatRoomType.Private]: chatEmployeeImage,
  };
  avatar = (avatar === null || avatar?.length === 0) ? null : avatar;

  return (
    <Avatar
      src={avatar ?? fallbackAvatar ?? defaultAvatar[roomType]}
      name={name ?? undefined}
      w={size ?? '40px'}
      h={size ?? '40px'}
      ignoreFallback
      bgColor="#D9D9D9"
    />
  );
};

export default ChatRoomThumbnail;
